import {getTotalSubscribers} from 'api/subscriptions';
import {useEffect, useState} from 'react';
import {alertByError} from 'utils/alerts';

function useGetTotalSubscribers() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});

  async function getData() {
    setIsLoading(true);
    try {
      const {data} = await getTotalSubscribers();
      setData(data);
    } catch (error) {
      alertByError(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return {
    isLoading,
    data,
  };
}

export default useGetTotalSubscribers;
